import { extractMarkedBlock } from "./markedBlock";

export type ParseEntry = { number: number; reason: string };

export type ParseMyDayPlanResult =
  | { ok: true; entries: ParseEntry[] }
  | { ok: false; reason: "no_markers" };

export function parseMyDayPlan(raw: string): ParseMyDayPlanResult {
  const block = extractMarkedBlock(raw);
  if (block === null) return { ok: false, reason: "no_markers" };

  const seen = new Set<number>();
  const entries: ParseEntry[] = [];

  for (const rawLine of block.split("\n")) {
    const line = rawLine.trim();
    if (line.length === 0) continue;
    const stripped = line.replace(/^[-*]\s*/, "");
    const m = stripped.match(/^(\d+)\s*(.*)$/);
    if (!m) continue;
    const number = parseInt(m[1], 10);
    if (seen.has(number)) continue;
    seen.add(number);
    entries.push({ number, reason: m[2].trim() });
  }

  return { ok: true, entries };
}
